/**
 * Created by pajicv on 10/10/18.
 */
import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import ProjectCycles from './ProjectCycles.enhancer';
import AddCylceButton from './AddCycleButton';
import { copyCycle } from '../../firebase/db';
import CyclesHistory from './CyclesHistory';

class CyclesContainer extends React.Component {

    state = {
      open: false,
      isCreatingCycle: false
    };


    handleOpen = () => {
        this.setState({ open: true })
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    //cycles index in project is 0 based
    handleAddNewCycleClick = () => {
        const { cycles, projectId, auth } = this.props;
        const numberOfCycles = Object.keys(cycles).length;
        const activeCycleId = Object.keys(cycles).pop();
        this.setState({ isCreatingCycle: true });
        copyCycle(projectId, activeCycleId, numberOfCycles, auth.email)
            .then(() => this.setState({ isCreatingCycle: false }));
    };

    render() {
        const { cycles, project, history, projectId } = this.props;
        const { open, isCreatingCycle } = this.state;
        const activeCycleId = Object.keys(cycles).pop();
        const activeCycleIndex = cycles[activeCycleId].index;
        const numberOfCycles = Object.keys(cycles).length;
        let selectedCycle;
        if(numberOfCycles > 1) {
            const cyclesKeys = Object.keys(cycles);
            cyclesKeys.pop();
            selectedCycle = cyclesKeys.pop();
        }

        return (
            <div>
                {selectedCycle && <Button
                    variant="contained"
                    onClick={this.handleOpen}
                >
                    View Previous Cycles
                </Button>}
                <AddCylceButton title="Add CX Cycle" onClick={this.handleAddNewCycleClick} disabled={isCreatingCycle} />
                <ProjectCycles history={history} cycleId={activeCycleId} projectTitle={project.title} index={activeCycleIndex} projectId={projectId} />
                {selectedCycle && <CyclesHistory history={history} cycles={cycles} selectedCycle={selectedCycle} activeCycle={activeCycleId} open={open} onClose={this.handleClose} project={project} />}
            </div>
        );
    }

}

export default withStyles({})(CyclesContainer);



// WEBPACK FOOTER //
// ./src/components/Cycles/CyclesContainer.js